/**
 * Query to fetch the list of active modules for populating the module filter dropdown.
 */
const fetchModulesListQuery = `
query FetchModulesList {
  modules(where: { is_active: { equalTo: true } }, first: 10000) {
    edges {
      node {
        objectId
        name
        sku
        is_product_line
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default fetchModulesListQuery;
